var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{staticClass:"pa-3",attrs:{"id":"app-breadcrumb","items":_vm.breadcrumbs,"divider":">"}}),_c('document-grid',{attrs:{"datasource":_vm.datasource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }